<template lang="pug">
  #app.black.bg-ltgray.font-pltn(:class="{'overflow-hidden-off h-100vh-off': loading}")
    header.sr-only
      h1 Daniel Benson
      h2 Photographer based in London
    .app__body(ref="body")
      //- viewer
      viewer#viewer(:projects="sortedProjects", :selectedID="activeProjectId", :showFooter="true || !introActive", :limitToFirstPrj="limitViewer", @endOfFirstPrj="scrollToIndexOnce")
      section#index.relative.bg-ltgray.min-h-100vh
        //- info btn
        //- transition(name="fade")
        info-btn.sticky.sm-fixed.z2.top-0.left-0.sm-opacity-100.transition-opacity.duration-600(:class="{'opacity-0': !navVisible}" @click="infoVisible = !infoVisible", style="height:0")
        //- index
        index(ref="index", :items="projects_index", @itemClick="viewProject")
    transition(name="fade")
      //- info
      footer.fixed.overlay.z2.bg-white-90.overflow-y-scroll.flex.flex-col.justify-between(v-show="infoVisible", @click="infoVisible = false")
        .w-100.p4.md-p3.sm-pt-1p7.sm-px2(v-if="site && site.about")
          .font-gs.h4.md-text-40.sm-text-19.uppercase.lh-2(v-html="$options.filters.richtext(site.about)", @click.stop="() => {}")
        credits.mt-40.p2.sm-h6(@click.native.stop="() => {}")
</template>

<script>
import Vue from 'vue'
import Prismic from 'prismic-javascript'
import Viewer from '@/components/SeriesViewer'
import Index from '@/components/SeriesIndex'
import InfoBtn from '@/components/InfoToggleBtn'
import Credits from '@/components/Credits'
import _throttle from 'lodash/throttle'
import _get from 'lodash/get'
import { disableScroll, enableScroll } from '@/plugins/toggleScroll'
export default {
  name: 'App',
  components: { Index, Viewer, InfoBtn, Credits },
  data () {
    return {
      loading: true,
      introActive: true,
      infoVisible: false,
      navVisible: false,
      site: null,
      projects_index: [],
      projects: [],
      activeProjectId: null,
      afterScroll: null,
      limitViewer: true,
      credits: false
    }
  },
  computed: {
    sortedProjects () {
      const prjs = []
      const ids = this.projects_index.map(prj => prj.primary.series.id)
      ids.map(id => {
        this.projects.map(prj => {
          if (id === prj.id) return prjs.push(prj)
        })
      })
      return prjs
    }
  },
  methods: {
    viewProject (id) {
      if (!id) return
      this.activeProjectId = id
      this.$scrollTo('#viewer', 800)
    },
    load () {
      const after = (ms, f) => setTimeout(f, ms)
      window.scrollTo(0, 0)
      this.$nextTick(disableScroll)
      return after(2000, () => {
        this.loading = false
        after(1000, () => {
          this.introActive = false
          enableScroll()
          window.addEventListener('scroll', this.onScroll)
        }, 1000)
      })
    },
    loadAtIndex () {
      // load at index
      window.scroll(0, this.$refs.index.$el.getBoundingClientRect().top)
      // this.navVisible = true
      window.addEventListener('scroll', this.onScroll)
      // end hidden elements
      // setTimeout(() => { this.introActive = false }, 3000)
    },
    onScroll: _throttle(function () {
      const y = window.pageYOffset
      const winH = window.innerHeight
      // show nav btn based on y pos
      this.navVisible = y >= winH
      // after scroll
      clearTimeout(this.afterScroll)
      this.afterScroll = setTimeout(() => {
        if (y > winH * 0.5 && y < winH) return this.$scrollTo('#index', 1200)
      }, 200)
    }, 50),
    scrollToIndexOnce () {
      this.limitViewer = false
      this.$scrollTo('#index', 1200, {cancelable: false})
    },
    setSite (data) {
      this.site = data
      const txt = this.$options.filters.text
      Vue.updateMeta._siteTitle = txt(data.title)
      Vue.updateMeta._siteDescription = txt(data.meta_description)
      Vue.updateMeta.set()
    },
    enforceHomeUrl () {
      // Remove this if being using routes / vue-router
      window.history.replaceState(null, document.title, '/')
    }
  },
  beforeCreate () {
    // Get content from Prismic
    Prismic.getApi(Vue.config.PrismicAPI).then(function (api) {
      return api.query(
        Prismic.Predicates.any('document.type', ['site', 'series_index', 'series']),
        { pageSize: 100, fetchLinks: ['series.title', 'series.client'] }
      )
    }).then(resp => {
      // save data to state
      resp.results.forEach(doc => {
        if (doc.type === 'site') this.setSite(doc.data)
        else if (doc.type === 'series_index') this.projects_index = doc.data.body
        else if (doc.type === 'series') this.projects.push({id: doc.id, ...doc.data})
      })
      // set initial active project
      this.activeProjectId = this.projects_index[0] ? _get(this.projects_index[0], 'primary.series.id') : null
    }).catch(err => console.error(err))
  },
  mounted () {
    // this.load()
    this.loadAtIndex()
    this.enforceHomeUrl()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style src="../node_modules/flickity/dist/flickity.css"></style>
<style>
@import 'style/variables';
@import 'style/atomic';
@import 'style/global';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:var(--basefont);
}

/* type / margin scaling */
@media (min-width:1440px) {
  html{font-size:calc(10 / 1440 * 100vw); } /* --rem */
  #app{font-size:calc(12 / 1440 * 100vw); } /* --basefont */
}
/* stop scaling at 1.5x (2160px) */
@media (min-width:2160px) {
  html{font-size:15px;}
  #app{font-size:18px;}
}

.app__body{
  transition:transform 1000ms;
}

.fade-enter-active,
.fade-leave-active{
  transition:opacity 600ms;
}
.fade-enter, .fade-leave-to{
  opacity:0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue